var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgIconClock = function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFE9A8",
    clipPath: "url(#icon-clock_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8 14.7A6.7 6.7 0 1 0 8 1.3a6.7 6.7 0 0 0 0 13.4Z"
  }), /*#__PURE__*/React.createElement(Path, {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 3.7V8l2.7 1.5"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "icon-clock_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconClock;